import React, { useState } from 'react';

import { Link, WorkflowViewContainer } from 'components/AORedesign';
import { SearchNewsArticles } from '../SearchNewsArticles';
import AddOrEditNewsArticle from './AddOrEditNewsArticle';

const EDIT_NEWS_ARTICLE_LABEL = 'Search/Edit News Articles';

const TriggerButton = (props) => (
  <Link {...props} startIcon={'editOutlined'}>
    {EDIT_NEWS_ARTICLE_LABEL}
  </Link>
);

const EditNewsArticle = () => {
  const [newsArticleId, setNewsArticleId] = useState(null);

  const handleSetNewsArticleId = (id) => setNewsArticleId(id);

  return (
    <WorkflowViewContainer appBarTitle={EDIT_NEWS_ARTICLE_LABEL} TriggerButton={TriggerButton} handleResetOnClose={() => handleSetNewsArticleId(null)}>
      {newsArticleId === null && <SearchNewsArticles handleSetNewsArticleId={handleSetNewsArticleId} />}
      {newsArticleId !== null && <AddOrEditNewsArticle searchEdit handleSetNewsArticleId={handleSetNewsArticleId} newsId={newsArticleId} />}
    </WorkflowViewContainer>
  );
};

export default EditNewsArticle;
